import { render, staticRenderFns } from "./InsDash.vue?vue&type=template&id=6d94b7c0&scoped=true&"
import script from "./InsDash.vue?vue&type=script&lang=js&"
export * from "./InsDash.vue?vue&type=script&lang=js&"
import style0 from "./InsDash.vue?vue&type=style&index=0&id=6d94b7c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d94b7c0",
  null
  
)

export default component.exports